import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import * as utils from '@utils'
import { API, RISKMGT } from '@const'
import { Grid, Button, FormControlLabel, Checkbox } from '@material-ui/core'
import Table from '@tables/table'
import ConfirmMsgDialog from '@msg/confirm-msg-dialog'
import EditRiskLabelDialog from '@risk/edit-risk-label-dialog'
import PfSubPfSelect from '@select/pf-sub-pf-select'
import { CheckCircleOutline, HighlightOff } from '@material-ui/icons'
import EditRiskControlStatusDialog from '@risk/edit-risk-control-status-dialog'
// const COMPONENT_GROUP = 'default_rtp_setting'
class DefaultRtpSettingPage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'DefaultRtpSettingPage')
        }
        const pfIDList = []
        Object.entries(this.props.dataService.pfSubPfMap).forEach(([_, elem]) => {
            if (!pfIDList.includes(elem['pf_id'])) pfIDList.push(elem['pf_id'])
        })

        this.pfSelectOption.extraPfSubPfList = {}

        pfIDList.forEach((pfID) => {
            const publicPfSubPfID = utils.ComposePublicPfSubPfId(pfID)

            this.pfSelectOption.extraPfSubPfList[publicPfSubPfID] = {
                is_active: true,
                name: this.t('publicGame'),
                pf_id: pfID,
                pf_sub_pf_id: publicPfSubPfID,
            }
        })
    }

    gameAdminColumns = [
        {
            field: 'oid',
        },
        {
            field: 'game_code',
        },
        {
            field: 'game_name',
            translate: {
                dataKey: 'game_code',
                tranKey: 'GameName',
            },
        },
        {
            field: 'rtp_level',
            render: (rowData) => {
                return (
                    <div className={this.props.classes.centerBox}>
                        <Button
                            variant="contained"
                            style={{ minWidth: '72px' }}
                            onClick={() => {
                                // 因位子層 selcet 預設選中的是從 rtp_level 設定 
                                // 所以如果是遊戲管理員 要先從此 rowData 所有 rtp 中取出第一個
                                const rowRtp = this.editDialog.sortRtpList(this.state.rtpList, rowData.oid, 'rtp')
                                const firstIndex = 0;
                                rowData.rtp_level = rowRtp[firstIndex];
                                rowData.pfId = this.pfSelect.state.pfId;
                                this.editDialog.OpenDialog(rowData, 'rtp')
                            }}
                            disabled={typeof this.state.rtpList[rowData.oid] === 'undefined'}
                            color="primary">
                            {this.t('setting')}
                        </Button>
                    </div>

                )
            },
        },
        {
            field: 'feature_buy_rtp_level',
            render: (rowData) => {
                return (
                    <div className={this.props.classes.centerBox}>
                        <Button
                            variant="contained"
                            style={{ minWidth: '72px' }}
                            onClick={() => {
                                // 因位子層 selcet 預設選中的是從 rtp_level 設定 
                                // 所以如果是遊戲管理員 要先從此 rowData 所有 rtp 中取出第一個
                                const rowRtp = this.editDialog.sortRtpList(this.state.rtpList, rowData.oid, 'feature')
                                const firstIndex = 0;
                                rowData.rtp_level = rowRtp[firstIndex];
                                rowData.pfId = this.pfSelect.state.pfId;
                                this.editDialog.OpenDialog(rowData, 'feature')
                            }}
                            disabled={typeof this.state.rtpList[rowData.oid] === 'undefined' || typeof this.state.rtpList[rowData.oid]['BUYSLOTGAME'] === 'undefined'}
                            color="primary">
                            {this.t('setting')}
                        </Button>
                    </div>

                )
            },
        },
        {
            field: 'risk_control_status',
            render: (rowData) => {
                return (
                    <div className={this.props.classes.centerBox}>
                        {
                            rowData.risk_control_status 
                                ? <CheckCircleOutline className={this.props.classes.checkCircle} />
                                : <HighlightOff className={this.props.classes.highlightOff} />
                        }
                    </div>
                )
            }
        }
    ]

    columns = [
        {
            field: 'pf_sub_pf_id',
            type: 'platform',
        },
        {
            field: 'oid',
        },
        {
            field: 'game_code',
        },
        {
            field: 'game_name',
            translate: {
                dataKey: 'game_code',
                tranKey: 'GameName',
            },
        },
        {
            field: 'rtp_level',
            cellStyle: { width: '250px', maxWidth: '350px' },
            render: (rowData) => {
                return (
                    <div className={utils.checkValid('default_rtp_setting.edit') ? this.props.classes.allowCotent : this.props.classes.centerBox}>
                        <span>{rowData.rtp_level}</span>
                        {utils.checkValid('default_rtp_setting.edit') && <Button
                            variant="contained"
                            style={{ minWidth: '72px', marginLeft: '15px' }}
                            onClick={() => {
                                this.editDialog.OpenDialog(rowData, 'rtp')
                            }}
                            color="primary"
                        >
                            {this.t('setting')}
                        </Button>}
                    </div> 
                )
            },
        },
        {
            field: 'feature_buy_rtp_level',
            cellStyle: { width: '200px', maxWidth: '300px' },
            render: (rowData) => {
                return (
                    rowData.feature_buy_rtp_level !== '-1' ? 
                    <div className={utils.checkValid('default_rtp_setting.edit') ? this.props.classes.allowCotent : this.props.classes.centerBox}>
                        <span>{rowData.feature_buy_rtp_level}</span>
                        {utils.checkValid('default_rtp_setting.edit') && <Button
                            variant="contained"
                            style={{ minWidth: '72px', marginLeft: '15px' }}
                            onClick={() => {
                                /** 設定feature buy時須先將原始的 rtp_level 和 id 更換為feature buy的參數  */
                                const newData = {...rowData, rtp_level: rowData.feature_buy_rtp_level, id: rowData.feature_buy_id}
                                this.editDialog.OpenDialog(newData, 'feature')
                            }}
                            color="primary"
                        >
                            {this.t('setting')}
                        </Button>}
                    </div> 
                    : ''
                )
            },
        }
    ]

    pfSelectOption = {
        hideAllPlatform: false,
        hideAllSubPlatform: true,
        hideAutocomplete: false,
        subPfChangeCallback: async () => {
            this.state.useGameAdmin ? this.table.SetData( await this.getPlatfromGaterpoolStatusList() ) : this.queryData()
        },
        hideCurrency: true,
    }

    componentDidMount() {
        // if (utils.checkValid(COMPONENT_GROUP + '.edit')) {
        //     this.columns.push({
        //         field: 'edit_rtp',
        //         hideTitle: true,
        //         render: (rowData) => {
        //             return (
        //                 <div className={this.props.classes.centerBox}>
        //                     <Button
        //                         variant="contained"
        //                         style={{ minWidth: '72px' }}
        //                         onClick={() => {
        //                             this.editDialog.OpenDialog(rowData)
        //                         }}
        //                         color="primary"
        //                     >
        //                         {this.t('setting')}
        //                     </Button>
        //                 </div>
        //             )
        //         },
        //     })
        // }
        if (utils.checkValid('platfrom_game_waterpool.edit')) {
            this.gameAdminColumns.push({
                field: 'risk_control_set',
                render: (rowData) => {
                    return (
                        <div className={this.props.classes.centerBox}>
                            <Button
                                variant="contained"
                                style={{ minWidth: '72px' }}
                                color="primary"
                                disabled={!this.state.sharedGamesOid.includes(rowData.oid)}
                                onClick={async () => {
                                    this.EditRiskControlStatusDialog.OpenDialog({
                                        // 把彈窗需用到的資料組合起來送給彈窗
                                        ...await this.getPlatfromGaterpool(rowData),
                                        pf_id: this.pfSelect.state.pfId,
                                        game_code: rowData.game_code,
                                        game_name: rowData.game_name
                                    })
                                }}
                            >
                                {this.t('setting')}
                            </Button>
                        </div>
                    )
                }
            })
        }
        this.getRtpList()
        this.getSharedGamesOid();
    }

    getRtpList() {
        utils.apiRequest(
            'get',
            API.RISKMGT_RTP_LEVEL_LIST,
            {},
            (data) => {
                this.setState({
                    rtpList: data
                })
            },
            (_err) => { },
            true
        )
    }

    async queryData() {
        this.table.SetLoading(true)

        try {
            const [riskLabelList, featureBuyList] = await Promise.all([
                new Promise((resolve, reject) =>
                    utils.apiRequest(
                        'get',
                        API.RISKMGT_GAME_RISK_INFO_LIST,
                        {
                            risk_label_list: [RISKMGT.RISK_LABEL_DEFAULT].join(),
                            pf_sub_pf_id: this.pfSelect.state.pfSubPfId,
                        },
                        (data) => {
                            resolve(Object.values(data))
                        },
                        (_err) => {
                            reject(_err)
                        },
                        true
                    )
                ),
                new Promise((resolve, reject) =>
                    utils.apiRequest(
                        'get',
                        API.RISKMGT_FEATURE_BUY_INFO_LIST,
                        {
                            risk_label_list: RISKMGT.RISK_FEATURE_BUY,
                            pf_sub_pf_id: this.pfSelect.state.pfSubPfId,
                        },
                        (data) => resolve(Object.values(data)),
                        (_err) => reject(_err),
                        true
                    )
                )
            ])

            /** 取得RTP及feature buy資訊對應oid後組合 */
            riskLabelList.forEach((item, index) => {
                const oid = item.oid
                const feature_buy_rtp_level = featureBuyList.find((item) => {
                    return item.oid === oid
                })

                riskLabelList[index]['feature_buy_rtp_level'] = feature_buy_rtp_level?.rtp_level || '-1'
                riskLabelList[index]['feature_buy_id'] = feature_buy_rtp_level?.id || null
            })
            this.setState({
                tableData: riskLabelList
            })
            this.table.SetData(this.state.tableData)
        } catch (error) {
            this.table.SetData([])
        }
    }

    async getPlatfromGaterpool(rowData) {
        return new Promise((resolve, reject) => {
            utils.apiRequest(
                'get',
                API.PLATFROM_GAME_WATERPOOL,
                {
                    pf_id: this.pfSelect.state.pfId,
                    oid: rowData.oid
                },
                (data) => resolve({
                    ...data,
                    current_profit_rate: this.EditRiskControlStatusDialog.calculateProfit(
                        Number(data.accumulated_profit),
                        Number(data.accumulated_bet),
                    )
                }),
                (_err) => reject({})
            )
        })
    }

    getSharedGamesOid() {
        this.setState({ 
            sharedGamesOid: this.props.dataService.gameList.reduce((value, item) => {
                if (item.code_id === '3') { value.push(item.oid) }
                return value
            }, [])
        })
    }

    async getPlatfromGaterpoolStatusList() {
        this.table.SetLoading(true)
        
        return new Promise((resolve, reject) => {
            utils.apiRequest(
                'post',
                API.PLATFROM_GAME_WATERPOOL_STATUS_LIST,
                {
                    pf_id: this.pfSelect.state.pfId,
                    oid: this.state.sharedGamesOid // 參數要帶全部共開遊戲的oid, code_id = 3 的為共開遊戲
                },
                (data) => {
                    // 將狀態列表重組成key為oid的物件
                    const statusList = Object.fromEntries(
                            data.map((item) => [item.oid, { is_control: item.is_control, pf_id: item.pf_id }])
                    )

                    // 將狀態列表跟遊戲料表組合
                    resolve(
                        this.props.dataService.gameList.map((item) => {
                            item.risk_control_status = statusList[item.oid] ? statusList[item.oid].is_control : false
                            return item
                        })
                    )
                },
                (_err) => reject([])
            )
        })
       
    }

    state = {
        useGameAdmin: false,
        pfSubPfListDisabled: false,
        gameList: [],
        tableData: [],
        rtpList: [],
        sharedGamesOid: [],
    }

    render() {
        return (
            <Grid container spacing={2}>
                <PfSubPfSelect onRef={(ref) => (this.pfSelect = ref)} options={this.pfSelectOption}></PfSubPfSelect>
                {        
                    utils.checkValid('platfrom_game_waterpool.view') && <FormControlLabel
                        className={this.props.classes.labelMarginClear}
                        label={this.t('Platform.gameManager')}
                        control={
                            <Checkbox
                                checked={this.state.useGameAdmin}
                                name="checked"
                                color="primary"
                                onChange={(event) => {
                                    const value = event.target.checked
                                    this.pfSelectOption.hideAllPlatform = value;
                                    this.pfSelectOption.hideAutocomplete = value
                                    if (this.pfSelectOption.hideAllPlatform && this.pfSelect.state.pfId === 'all') {
                                        this.pfSelect.setState({
                                            pfId: this.pfSelect.state.pfList[0]
                                        })
                                    }
                                    this.setState(() => {
                                        return {
                                            useGameAdmin: value,
                                            pfSubPfListDisabled: false
                                        }
                                    }, async () => {
                                        if (this.state.useGameAdmin) {
                                            this.table.setColumns()
                                            this.table.SetData( await this.getPlatfromGaterpoolStatusList() )
                                        } else {
                                            this.table.setColumns()
                                            this.table.SetData(this.state.tableData);
                                            this.queryData();
                                        }
                                    })
                                }
                                }
                            >
                            </Checkbox>
                        }
                    >
                    </FormControlLabel>
                }
                <Grid item xs={12}>
                    <Table
                        ownerName="DefaultRtpSettingPage"
                        columns={this.state.useGameAdmin ? this.gameAdminColumns : this.columns}
                        options={{
                            orderIdx: 1,
                        }}
                        onRef={(ref) => (this.table = ref)}
                    />
                    <ConfirmMsgDialog onRef={(ref) => (this.confirmDialog = ref)} />
                    <EditRiskLabelDialog
                        confirmCallback={() => {
                            if (!this.state.useGameAdmin) {
                                this.queryData()
                            }
                        }}
                        useGameAdmin={this.state.useGameAdmin}
                        onRef={(ref) => (this.editDialog = ref)}
                    />
                    <EditRiskControlStatusDialog 
                        onRef={(ref) => {this.EditRiskControlStatusDialog = ref}}
                        onConfirm={ async () => { this.table.SetData( await this.getPlatfromGaterpoolStatusList() ) }}
                    />
                </Grid>
            </Grid>
        )
    }
}

const styles = (_theme) => {
    return {
        labelMarginClear: {
            margin: 0,
        },
        checkCircle: {
            color: '#36B37E',
        },
        highlightOff: {
            color: '#FF5630',
        },
        centerBox: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        allowCotent: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        }
    }
}

DefaultRtpSettingPage.propTypes = {
    classes: PropTypes.object.isRequired,
    dataService: PropTypes.object,
}

export default hoc(styles)(DefaultRtpSettingPage)
